import debug from 'debug';

const log = debug('Querystring');

class Querystring {
	
	constructor() {
	}

	ObjToQuerystring(obj) {
		log('obj', obj)
		return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&');
	}

}

export default Querystring;
